import { createContext, useContext } from 'react';
export const ResponsiveContext = /*#__PURE__*/ createContext();
export const useResponsiveContext = ()=>useContext(ResponsiveContext);
export const ResponsiveContextProvider = ResponsiveContext.Provider;
